import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  Media: {
    height: '100%',
    width: '100%',
  },

  '.MuiInputLabel-root': {
    color: 'red',
  },

  container: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    color: 'black',
  },

  mainWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'calc(100vh - 50px)',
  },

  leftWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    width: '100%',
  },

  paperWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '30px',
    width: '100%',
    height: '100%',
  },

  insideH1: {
    marginBottom: 15,
    fontSize: '180%',
    fontWeight: 'normal',
    lineHeight: '30px',
  },

  insideH2: {
    marginBottom: 15,
    fontWeight: '300',
    fontSize: '26px',
    lineHeight: '32px',
  },

  insideH5: {
    marginTop: 0,
    marginBottom: 20,
    fontWeight: '300',
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0.15px',
  },

  insideH4: {
    marginTop: 0,
    fontWeight: 'normal',
  },

  logoImage: {
    width: '50%',
    height: '50px',
    marginLeft: 0,
    marginRight: 'auto',
  },

  formBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    width: '480px',
  },

  accountOptions: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },

  formTitle: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'start',
    textAlign: 'left',
    lineHeight: 1.3,
    marginTop: 40,
    marginBottom: 24,
    width: '100%',
    fontWeight: 'normal',
  },

  linearProgress: {
    marginTop: '20px',
  },

  alert: {
    width: '100%',
    marginTop: 10,
    marginBottom: '10px',
    padding: '1px 16px 1px 16px',
  },

  footer: {
    marginTop: 'auto',
    backgroundColor: '#E7EAED',
    padding: '10px 10px 15px 10px',
  },

  signupLink: {
    paddingTop: 15,
    textAlign: 'center',
  },

  forgotPasswordLink: {
    paddingTop: 15,
    textAlign: 'center',
  },

  messageWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0 5px 35px 5px',
    backgroundColor: '#D2E6DE',
    width: '100%',
    marginTop: '30px',
    fontSize: '90%',
    borderRadius: '4px',
  },

  iconWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'end',
    alignItems: 'end',
    alignSelf: 'end',
  },

  messageTextWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    padding: '0 20px 0 20px',
    marginTop: '-20px',
    marginBottom: '-20px',
    width: '100%',
  },

  signIn: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '1rem',
    marginTop: '0.5rem',
    marginBottom: '0.25rem',
  },

  googleText: {
    marginLeft: '0.675rem',
    font: 'Sora',
    fontWeight: 600,
    fontSize: '0.975rem',
    textTransform: 'uppercase',
    color: theme.palette.primary.main,
  },

  googleBtn: {
    padding: '0.8rem',
  },
}))

export { useStyles }
